import Box from '@mui/material/Box';
import { RouterProvider } from 'react-router-dom';
import { router } from "./utils/Router"
import React from "react";
import { AuthProvider } from './utils/AuthContext'

export default function App() {

    return (
        <AuthProvider>
            <React.StrictMode>
                <Box sx={{ flexGrow: 1 }}>
                    <RouterProvider router={router} />
                </Box>
            </React.StrictMode>
        </AuthProvider>
    );
}
